import { useState, useEffect, useCallback } from 'react';
import OutsourcedUserFteService from '../../Services/OutsourcedUserFte/OutsourcedUserFteService';

function getIobTargetMonth() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1; // 1-based current month (next IOB run on the 1st will process this month)
  return { year, month };
}

export default function useFteWarnings() {
  const [warnings, setWarnings] = useState(null);

  const fetchWarnings = useCallback(() => {
    const { year, month } = getIobTargetMonth();
    OutsourcedUserFteService.GetWarnings(year, month)
      .then((response) => {
        if (response && !response.error) {
          setWarnings(response);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    fetchWarnings();
  }, [fetchWarnings]);

  return { warnings, refreshWarnings: fetchWarnings };
}
